import { uniq } from 'lodash-es'
import { ReactGoogleChartProps } from 'react-google-charts'
import { ParsedChartProps } from 'types'
import { useTheme } from 'utils'
import GoogleChart from '../GoogleChart'
import { defaultChartProps, makeChartData, makeDefaultChartOptions } from '../chartUtils'

export default function ComboChart({ onSelect, ...props }: ParsedChartProps) {
  const { theme: colorMode } = useTheme()

  const defaultProps = makeDefaultChartOptions(props)
  const { secondaryAxisTitle, primaryAxisTitle, legend, orientation, values, data, categories } =
    props

  const seriesMultiplier = categories[1]
    ? uniq(data.map(d => d[categories[1]] || 'Unset')).length
    : 1
  const seriesConfig = values.map(({ type, axis }) => ({
    type,
    targetAxisIndex: axis === 'secondary' ? 1 : 0,
  }))
  const series = new Array(seriesMultiplier).fill(0).reduce(acc => [...acc, ...seriesConfig], [])

  const options: ReactGoogleChartProps['options'] = {
    ...defaultProps,
    seriesType: 'bars',
    orientation: orientation === 'bar' ? 'vertical' : 'horizontal',
    series,
    chartArea: {
      left: orientation === 'bar' ? 160 : secondaryAxisTitle ? 90 : 50,
      right: legend?.show ? 200 : secondaryAxisTitle ? 90 : 50,
      top: 20,
      bottom: 30,
    },
    vAxes: {
      0: {
        viewWindow: {
          min: 0,
        },
        title: primaryAxisTitle,
        titleTextStyle: { color: colorMode === 'light' ? '#333' : '#CCC' },
      },
      1: {
        viewWindow: {
          min: 0,
        },
        gridlines: {
          color: '',
        },
        minorGridlines: {
          color: '',
        },
        title: secondaryAxisTitle,
        titleTextStyle: { color: colorMode === 'light' ? '#333' : '#CCC' },
        textStyle: { color: '#E77522' },
      },
    },
  }

  return (
    <GoogleChart
      {...defaultChartProps}
      chartType="ComboChart"
      data={makeChartData(props)}
      options={options}
      onSelect={onSelect}
    />
  )
}
